// src/components/PinInput.jsx
//
// Masked PIN field. Renders a real <input type="password"> so the browser
// handles masking, but also surfaces the visual fill indicator (●●●●●○) and
// a "N of 6" counter beneath. The user only ever sees dots from the browser;
// our length counter tells them how far they've gone.

export default function PinInput({
  label,
  value,
  onChange,
  onKeyDown,
  maxLength = 6,
  autoFocus,
}) {
  // Always render a fixed number of slots so the layout doesn't shift.
  const slots = Array.from({ length: maxLength });
  return (
    <div className="space-y-2">
      <label className="block font-mono text-[11px] tracking-[0.16em] uppercase text-aught-ash">
        {label}
      </label>

      {/* The real input — invisible to the user, but we want native
          autofill/mobile-keyboard behavior. The visible row beneath it is
          the dot indicator. */}
      <div className="relative">
        <input
          type="password"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
          autoComplete="off"
          spellCheck={false}
          inputMode="numeric"
          maxLength={maxLength}
          className="absolute inset-0 opacity-0 cursor-pointer"
          aria-label={label}
        />
        <div className="flex items-center gap-3 hairline focus-within:border-aught-oxide transition-colors duration-200 ease-out-soft py-3 pointer-events-none">
          <div className="flex items-center gap-2.5 font-mono text-2xl text-aught-ink tabular">
            {slots.map((_, i) => (
              <span key={i} className="inline-block w-3 text-center select-none">
                {i < value.length ? "●" : "○"}
              </span>
            ))}
          </div>
        </div>
      </div>

      <p className="font-mono text-[11px] text-aught-ash tabular">
        {value.length} of {maxLength}
      </p>
    </div>
  );
}
